/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sprachanforderungen_AndereInputs */

const de_sprachanforderungen_andere = /** @type {(inputs: Sprachanforderungen_AndereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Sprachanforderungen`)
};

/** @type {(inputs: Sprachanforderungen_AndereInputs) => LocalizedString} */
const en_sprachanforderungen_andere = () => /** @type {LocalizedString} */ ('sprachanforderungen_andere')

/**

* @param {Sprachanforderungen_AndereInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sprachanforderungen_andere = /** @type {((inputs?: Sprachanforderungen_AndereInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sprachanforderungen_AndereInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sprachanforderungen_andere(inputs)
	return en_sprachanforderungen_andere(inputs)
});